// ----------------------------------------------------------------------
export const Popover = ({ theme }) => {
    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    boxShadow: theme.shadows[25].z12
                }
            }
        }
    };
};
//# sourceMappingURL=Popover.js.map